import { defineMessages } from 'react-intl';

export const messages: {
	createdDateASC: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	createdDateASCSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	createdDateDESC: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	createdDateDESCSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	latestModifiedDateASC: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	latestModifiedDateASCSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	latestModifiedDateDESC: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	latestModifiedDateDESCSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sortOptionsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	latestModifiedDateDESC: {
		id: 'dynamic-cards-search-page.results-sort.latestModifiedDateDESC',
		defaultMessage: 'Updated (newest)',
		description:
			'Option in the dropdown to sort search results by the last updated date, order descending',
	},
	latestModifiedDateDESCSelected: {
		id: 'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected',
		defaultMessage: 'Sort by updated (newest)',
		description:
			'Text displayed in the dropdown indicating that search results are currently sorted by the last updated date, order descending',
	},
	latestModifiedDateASC: {
		id: 'dynamic-cards-search-page.results-sort.latestModifiedDateASC',
		defaultMessage: 'Updated (oldest)',
		description:
			'Option in the dropdown to sort search results by the last updated date, order ascending',
	},
	latestModifiedDateASCSelected: {
		id: 'dynamic-cards-search-page.results-sort.latestModifiedDateASC.selected',
		defaultMessage: 'Sort by updated (oldest)',
		description:
			'Text displayed in the dropdown indicating that search results are currently sorted by the last updated date, order ascending',
	},
	createdDateDESC: {
		id: 'dynamic-cards-search-page.results-sort.createdDateDESC',
		defaultMessage: 'Created (newest)',
		description:
			'Option in the dropdown to sort search results by the last created date, order descending',
	},
	createdDateDESCSelected: {
		id: 'dynamic-cards-search-page.results-sort.createdDate.selected',
		defaultMessage: 'Sort by created (newest)',
		description:
			'Text displayed in the dropdown indicating that search results are currently sorted by the last created date, order descending',
	},
	createdDateASC: {
		id: 'dynamic-cards-search-page.results-sort.createdDateASC',
		defaultMessage: 'Created (oldest)',
		description:
			'Option in the dropdown to sort search results by the last created date, order ascending',
	},
	createdDateASCSelected: {
		id: 'dynamic-cards-search-page.results-sort.createdDateASC.selected',
		defaultMessage: 'Sort by created (oldest)',
		description:
			'Text displayed in the dropdown indicating that search results are currently sorted by the last created date, order ascending',
	},
	sortOptionsLabel: {
		id: 'dynamic-cards-search-page.results-sort.sort-options.label',
		defaultMessage: 'Change list sorting',
		description: 'Text to label the sort options dropdown button',
	},
});
